import React, { useEffect, useState } from 'react';
import { database } from '../../../utils/firebase';


const LangCaptComponent = ({langCode, langId, language, live }) => {
    const [lang, setLang] = useState([]);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        const enRef = database.ref(langCode)
            enRef.on('value', (el) => {   
                let eData = [] 
                for (let id in el.val()) {
                    eData.push({id, language: language, ...el.val()[id]})
                } 
                setLang(eData)
                setLoaded(true)
            })
    }, [langCode, langId])

    const handleGoLive = (id) => {
        const langRef = database.ref('Languages').child(id)
            langRef.update({
                live: true
        })
    }

    const handleLive = (id) => {
        const langRef = database.ref('Languages').child(id)
        langRef.update({
            live: false
        })
    }

    return (
        <div className="lang-capt" >
            <h4>{language}</h4>
            <div className="capt-field">
                <div className='container'>
                    <div className='speech-to-text'>
                        {loaded? 
                        
                        lang.map(el1 => {
                            if(language === el1.language) {
                                return (
                                    <p key={el1.id}>{el1.text}</p>
                                )
                            } 
                        }) : ''}
                    </div>
                </div>
                {live? <button onClick={() => handleLive(langId)}>LIVE</button>: <button className='go-live' onClick={() => handleGoLive(langId)}>GO LIVE</button>}                           
            </div>
        </div>
    )
}

export default LangCaptComponent